import adanPic from "@/public/images/artists/adan.png";
import { Artist } from "@/types/types";

export const adan = {
  id: "217",
  name: "Adan",
  image: adanPic,
  description: `Adan's voice is light and grounded, with a relaxed flow that's smooth and unforced—a rap voice versatile enough to work across various styles, with a mid-range register and an approachable tone.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fadan-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Dance", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 68,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
